class AccessoryPDP {
  constructor() {
    this.mql = window.matchMedia("(max-width: 768px)");
    this.mql.addListener(this.initOrDestroySwiper.bind(this));
    if (this.mql.matches) {
      this.initMainProductSwiper();
    }
  }

  initOrDestroySwiper(e) {
    if (e.matches) {
      this.initMainProductSwiper();

    } else {
      this.swiper.destroy();
      if (this.thumbsSwiper) {
        this.thumbsSwiper.destroy();
      }
    }
  }

  initMainProductSwiper() {
    this.thumbsSwiper = new Swiper('.ProdSwiperThumbs', {
      slidesPerView: 4.5,
      spaceBetween: 20,
      threshold: 10,
      roundLengths: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        767: {
          slidesPerView: 4.5,
          spaceBetween: 20,
        },
        1025: {
          slidesPerView: 5,
          spaceBetween: 44,
        },
      },
    });

    this.swiper = new Swiper('.MPCMainSlider.swiper-container', {
      slidesPerView: 1,
      threshold: 10,
      roundLengths: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: '.MPCMainSlider__Pagination',
        type: 'bullets',
        clickable: true,
      },
      thumbs: {
        swiper: this.thumbsSwiper,
      },
      breakpoints: {},
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const mainSlider = document.querySelector('.MPCMainSlider.swiper-container');
  if (mainSlider && !mainSlider.swiper) {
    new AccessoryPDP();
  }
});
